module.exports = __webpack_public_path__ + "static/media/th.904dd785.svg";